import React from 'react';
import { useLoading } from '../../context/LoadingContext';

const GlobalLoadingIndicator = () => {
  const { isLoading } = useLoading();

  if (!isLoading) return null;

  return (
    <>
      {/* Top progress bar */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: '3px',
        zIndex: 99999,
        background: 'rgba(0,0,0,0.08)',
        overflow: 'hidden',
      }}>
        <div style={{
          height: '100%',
          width: '40%',
          background: 'linear-gradient(90deg, var(--color-burgundy, var(--color-burgundy)), var(--color-rose, #C77D8F), var(--color-burgundy, var(--color-burgundy)))',
          borderRadius: '0 2px 2px 0',
          animation: 'globalLoadingSlide 1.2s ease-in-out infinite',
        }} />
      </div>
    </>
  );
};

export default GlobalLoadingIndicator;
